import React from 'react';

const FilteredEllipse = ({ className }: { className?: string }) => {
    return (
        <svg
            className={'blur ' + className}
            width="923"
            height="582"
            viewBox="0 0 1440 1270"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_f_2015_5747)">
                <ellipse
                    cx="722.847"
                    cy="634.995"
                    rx="460.316"
                    ry="280.405"
                    transform="rotate(30 722.847 634.995)"
                    fill="#2C93F3"
                    fillOpacity="0.3"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_2015_5747"
                    x="0.151367"
                    y="0.416016"
                    width="1445.39"
                    height="1269.16"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_2015_5747" />
                </filter>
            </defs>
        </svg>
    );
};

export default FilteredEllipse;
